import { render, staticRenderFns } from "./UsersGradient.vue?vue&type=template&id=833cae80"
import script from "./UsersGradient.vue?vue&type=script&lang=js"
export * from "./UsersGradient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports